import { User } from 'firebase';
import { AngularFireAuth } from '@angular/fire/auth';
import { FirestoreService } from 'common-lib';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  currentUser: User;

  constructor(private fire: FirestoreService, private auth: AngularFireAuth) {
    auth.user.subscribe((user) => {
      this.currentUser = user;
    });
  }

  async getProfile() {
    const user = this.currentUser;

    if (!user || user.isAnonymous) {
      return null;
    }

    try {
      const profile = await this.fire.doc(`profiles/${user.uid}`).get().toPromise();
      if (profile.exists) {
        return { ...profile.data(), email: this.auth.auth.currentUser.email };
      } else {
        return null;
      }
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async isValidProfile() {
    const profile: any = await this.getProfile();
    if (!profile) {
      return false;
    }
    return (
      !!profile.email && !!profile.companyPost && !!profile.industry && !!profile.jobType && !!profile.annualIncome
    );
  }

  didEntryJob$(jobId: string) {
    const user = this.currentUser;
    if (!user) {
      return new Observable<boolean>((sub) => {
        sub.next(false);
      });
    }
    return this.fire
      .col$(`profiles/${user.uid}/entries`, (ref) => ref.where('job', '==', this.fire.doc(`jobs/${jobId}`).ref))
      .pipe(
        map((doc) => {
          if (doc && doc.length > 0) {
            return true;
          }
          return false;
        })
      );
  }
}
